import React, { Component } from 'react';

import TicketBox from './TicketBox';
import IconTicket from '../../assets/icons/IconTicket';
import IconTicketChecked from '../../assets/icons/IconTicketChecked';
import IconTicketLate from '../../assets/icons/IconTicketLate';
import IconTicketLoading from '../../assets/icons/IconTicketLoading';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';

class TicketBoxListSolution extends Component {
    filterStatus = status => {
        const filtered = this.props.data.filter((ticket) => ticket.status === status);
        return filtered.length;
    };

    filterDataTracker = status => {
        if (status === 'all') {
            const filtered = this.props.data;
            return {
                whatsapp: filtered.filter((ticket) => ticket.tracker === 'chat').length,
                phone: filtered.filter((ticket) => ticket.tracker === 'phone').length,
                email: filtered.filter((ticket) => ticket.tracker === 'email').length,
                grochat: filtered.filter((ticket) => ticket.tracker === 'grochat').length,
                status
            };
        }

        if (status === 'overdue') {
            const filtered = this.props.data.filter((ticket) => ticket.is_locked === true);
            const result = [];
            const csDict = {};
            for (const item of filtered) {
                const { cs, id: ticketId, ticket_no: ticketNo, status, assignee_id } = item;
                if (!(cs in csDict)) {
                    csDict[cs] = { cs, ticket_id: [], ticket_no: [], status, assignee_id };
                }
                csDict[cs].ticket_id.push(ticketId);
                csDict[cs].ticket_no.push(ticketNo);
                csDict[cs].status = status;
                csDict[cs].assignee_id = assignee_id;
            }
            for (const key in csDict) {
                result.push(csDict[key]);
            }
            result.sort((a, b) => a.cs.localeCompare(b.cs));
            return result;
        }

        const filtered = this.props.data.filter((ticket) => ticket.status === status);
        const result = [];
        const csDict = {};
        for (const item of filtered) {
            const { cs, id: ticketId, ticket_no: ticketNo, status, assignee_id } = item;
            if (!(cs in csDict)) {
                csDict[cs] = { cs, ticket_id: [], ticket_no: [], status, assignee_id };
            }
            csDict[cs].ticket_id.push(ticketId);
            csDict[cs].ticket_no.push(ticketNo);
            csDict[cs].status = status;
            csDict[cs].assignee_id = assignee_id;
        }
        for (const key in csDict) {
            result.push(csDict[key]);
        }
        result.sort((a, b) => a.cs.localeCompare(b.cs));
        return result;
    }

    render() {
        return (
            <>
                {/* Dashboard Ticket box 2nd Row */}
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnresolved" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.RESOLVED))} titleTicket="resolved" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.RESOLVED)} iconTicket={<IconTicketChecked />} textColor="text-nexcaregreen1" iconBoxColor="bg-nexcaregreen1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnclosed" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.CLOSED))} titleTicket="closed" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.CLOSED)} iconTicket={<IconTicketChecked />} textColor="text-nexcaresalmon1" iconBoxColor="bg-nexcaresalmon1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnunderobservation" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.UNDER_OBSERVATION))} titleTicket="under observation" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.UNDER_OBSERVATION)} iconTicket={<IconTicketLoading />} textColor="text-nexcarepurple1" iconBoxColor="bg-nexcarepurple1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btntotalticket" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker('all'))} titleTicket="total tiket diterima" totalTicket={this.props.data.length} iconTicket={<IconTicket />} textColor="text-nexcareblue3" iconBoxColor="bg-nexcareblue3" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnoverdueticket" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker('overdue'))} titleTicket="tiket terlambat" totalTicket={this.props.data.filter((ticket) => ticket.is_locked === true).length} iconTicket={<IconTicketLate />} textColor="text-nexcareorange3" iconBoxColor="bg-nexcareorange3" />
                </div>
            </>
        );
    }
}

export default TicketBoxListSolution;